import React, { useState, useEffect } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default function FAQ() {
    const [content, setContent] = useState(""); // HTML content from API
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
    const [accessModulesData, setAccessModulesData] = useState([]);

    // Fetch FAQ content
    const fetchFAQ = async () => {
        try {
            setLoading(true);
            let res = await window.Platform.database.getFAQ();
            if (res.status && Array.isArray(res.data) && res.data.length > 0) {
                setContent(res.data[0].name || "");
            }
        } catch (err) {
            console.error("Error fetching FAQ:", err);
        } finally {
            setLoading(false);
        }
    };

      const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                userId : userData?.id,
                moduleId : "1iK1kZyFAQ"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                // window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchAccessModules();
        fetchFAQ();
    }, []);

    // Fix links that start with www.
    function fixLinks(html) {
        return html.replace(/<a\s+([^>]*?)href=["'](www\.[^"'>]+)["']/gi, '<a $1href="https://$2"');
    }

    // Save FAQ content
    const saveFAQ = async () => {
        try {
            const fixedContent = fixLinks(content);
            const htmlDoc = `<!doctype html>
<html>
<head><meta charset="utf-8"/></head>
<body>
${fixedContent}
</body>
</html>`;

            await window.Platform.database.updateFAQ({ htmlContent: htmlDoc });
            window.NotificationUtils?.showSuccess?.("FAQ saved successfully!");
            setEditMode(false);
            fetchFAQ();
        } catch (err) {
            console.error("Error saving FAQ:", err);
            window.NotificationUtils?.showError?.("Save failed");
        }
    };

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: "50px" }}>Loading...</div>;
    }

    return (
        <div style={{ maxWidth: "", margin: "30px 20px 20px 20px", fontFamily: "Segoe UI, sans-serif" }}>
            <div
                style={{
                    background: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    padding: "25px 30px",
                }}
            >
                {accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" &&  userData.role.includes("admin") && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h2 style={{ fontWeight: "600", color: "#2c3e50" }}>FAQ</h2>
                        {!editMode && (
                            <button onClick={() => setEditMode(true)} style={buttonStyleEdit}>✏️ Edit</button>
                        )}
                    </div>
                )}

                <div style={{ marginTop: "20px" }}>
                    {editMode ? (
                        <>
                            {/* <CKEditor
                                editor={ClassicEditor}
                                data={content}
                                onChange={(event, editor) => setContent(editor.getData())}
                                config={{
                                    toolbar: [
                                        'heading', '|',
                                        'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                                        'insertTable', 'undo', 'redo'
                                    ]
                                }}
                            /> */}
                            <CKEditor
                                editor={ClassicEditor}
                                data={content}
                                onChange={(event, editor) => setContent(editor.getData())}
                                config={{
                                    toolbar: [
                                        'heading', '|',
                                        'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                                        'insertTable','undo', 'redo'
                                    ],
                                    mediaEmbed: {
                                        previewsInData: true
                                    }
                                    // For custom upload adapter, you can add extra config here
                                }}
                            />
                            <div style={{ textAlign: "right", marginTop: "15px" }}>
                                <button onClick={() => setEditMode(false)} style={buttonStyleEdit}>⬅ Back</button>
                                <button onClick={saveFAQ} style={buttonStyleSave}>💾 Save</button>
                            </div>
                        </>
                    ) : (
                        // <iframe
                        //     title="faq-display"
                        //     srcDoc={content}
                        //     style={{
                        //         width: "100%",
                        //         minHeight: "400px",
                        //         border: "1px solid #ccc",
                        //         borderRadius: "10px",
                        //     }}
                        // />
                        <iframe
                            title="faq-display"
                            srcDoc={`
        <style>
            body { font-family: "Segoe UI", sans-serif; padding: 10px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
        </style>
        ${content}
    `}
                            style={{
                                width: "100%",
                                minHeight: "400px",
                                border: "1px solid #ccc",
                                borderRadius: "10px",
                            }}
                        />

                    )}
                </div>
            </div>
        </div>
    );
}

// Styles
const buttonStyleEdit = {
    background: "linear-gradient(135deg, #17a2b8, #138496)",
    border: "none",
    borderRadius: "30px",
    color: "white",
    padding: "8px 10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
    marginRight: "10px"
};

const buttonStyleSave = {
    background: "linear-gradient(135deg, #28a745, #218838)",
    border: "none",
    borderRadius: "30px",
    color: "white",
    padding: "8px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
};
